export default __webpack_public_path__ + "static/char-thumb-33-a4e7dc53ea2d16e5e7fb2c4f3cb3760e.png";